import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from '../../../../../../projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdModalContent } from '../../../../../../projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from '../../../../../../projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from '../../../../../../projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CurrentLanguage } from '../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { NgbdSortableHeader, SortEvent } from '../../../../../../projects/Autofacets-Core/src/app/directives/sortable.directive';
import { UserDataService } from '../../../../../../src/app/DataServices/user-data.service';
import * as fromEnums from '../../../../../../projects/Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';

import { VehicleType } from '../../business-entities/vehicle-list-view-model';
import { AddPreferencesComponent } from '../preferences/add-preferences/add-preferences.component';
import { PreferenceBusinessService } from '../../business-services/preference.service';
import { ActiveDealerDataMapper, Preferences } from '../../business-entities/preferences-model';
import { EditPreferencesComponent } from './edit-preferences/edit-preferences.component';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { DealerRequestModel } from '../../business-entities/dealer-view-model';
@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.css']
})
export class PreferencesComponent implements OnInit, OnDestroy {
  @ViewChild('content') content: ElementRef;
  language: string;
  total$: Observable<number>;
  popupCloseResult = false;
  fileName = 'ExcelSheet.xlsx';
  SelectedVehical: any;
  confrimationTitle: string
  paginationSub: Subscription
  currentlagSub: Subscription
  currentDateTime: Promise<Date>;
  preferenceList: Preferences[];
  userRoleRightsDetails: UserRoleMenu;
  vehicleTypes: VehicleType[] = [];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  confrimationMessage: any;
  allDealerList: any[];
  dealerRequestModel:DealerRequestModel = {
    statusId: 0,
    keyLocation:false,
    onlinePayment:false,
    isAdvanceSearch:false,
    isAllDealer:true,
    startRecordNumber: 0,
    PageSize: 25,
    SortColumn: 'Name',
    sortDirection: 'DESC',
    searchTerm: '',
    isForList: true
  };
  constructor(
    private preferenceService: PreferenceBusinessService,
    public pService: CustomPaggerService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router,
    private cookieservice: CookieService,
    private currentLanguageService: CurrentLanguage,
    private cd: ChangeDetectorRef,
    private userService: UserDataService,
    public dealerBusinessService: DealerBusinessService,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['brand', 'Question', 'Active'];
    this.pService.searchTerm = '';

  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

  async getPreferenceList() {
    this.spinner.show();
    let language = this.cookieservice.get('userSelectedLanguage')
    let requestObj =
    {
      LANGUAGECODE: language
    }
    await this.preferenceService.getPreferenceList(requestObj).then((response) => {
      this.pService.dataSource = response;
      this.paginationSub = this.pService.dealers$.subscribe(result => {
        this.preferenceList = this.preferenceMapping(result);
      });
    })
    this.spinner.hide();
  }

  private preferenceMapping(manualList: any) {
    let supperArray = [];
    if (manualList && manualList.length > 0) {

      for (let index = 0; index < manualList.length; index++) {
        const element = manualList[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.brandId = element.brandId;
        single.question = element.question;
        single.description = element.description;
        single.preferenceImage = element.preferenceImage === null ? './../../../assets/images/no-img.png' : element.preferenceImage;
        single.createdBy = element.createdBy;
        single.createdDate = element.createdDate;
        single.updatedBy = element.updatedBy;
        single.updatedDate = element.updatedDate;
        single.brand = element.brand;
        single.isActive = element.isActive;
        single.answerInputs = element.answerInputs;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.Preferences);
    this.pService.dataSource = [];
    this.getAllDealerList(this.dealerRequestModel);
    this.cd.detectChanges();
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.getPreferenceList()
    });
    setInterval(() => {
      this.currentDateTime = Promise.resolve(new Date());
    }, 1000);
  }

  onEdit(id: number) {
    this.preferenceService.PreferenceId = id
    const modalref = this.modalService.open(EditPreferencesComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
  onAdd() {
    const modalref = this.modalService.open(AddPreferencesComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  refresh() {
    this.getPreferenceList();
  }

  onActiveOrInactive(id: any) {
    let modelHeadermsg = this.translate.instant("lblActivateDeactivate");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblActiveInactive"), this.translate.instant("lblPreferences"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    let requestObj =
    {
      PreferenceId: id
    }
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.preferenceService
          .activeInactivePreference(requestObj)
          .then((res) => {
            if (res.responseCode == Constant.SuccessResponseCode) {
              let successmsg = this.translate.instant("lblPreferenceStatus");
              this.toastr.success(successmsg);
              this.getPreferenceList();
            }
            this.spinner.hide();
          },
            (err) => {
              this.spinner.hide();
              this.toastr.error(err);
            });
      }
    });
  }

  deletePreference(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblPreferences"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.preferenceService.deletePreference(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let deletedmsg = this.translate.instant("lblPreferenceDeleted");
            this.toastr.success(deletedmsg)
            this.getPreferenceList();
          }
        });
      }
    });
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  /**
* Method to generate auto row number based on per page size
* @param cIndex
*/
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }
  
  async getAllDealerList(dealerRequestModel: DealerRequestModel) {
    this.spinner.show();
    await this.dealerBusinessService.getDealerList(dealerRequestModel).then((response) => {
      this.allDealerList = this.activeDealerDataMapper(response);
      this.getAllActiveDealer();
    });
  }

  private activeDealerDataMapper(response){
    let supperArray = [];
    if (response && response.length > 0) {
      response.forEach(element=>{
        let single = new ActiveDealerDataMapper();
        single.dealerId = element.dealerId;
        single.dealerName = element.name;
        single.isDealerActive = element.isActive;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async activeInactiveDealer(evt, dealerId, isActive, content) {
    evt.preventDefault();
    this.confrimationTitle = this.translate.instant("lblPreferences");
    if (evt.target.checked) {
      this.confrimationMessage = this.translate.instant("lblActiveDealerPreferenceMessage");
    }
    else {
      this.confrimationMessage = this.translate.instant("lblInActiveDealerPreferenceMessage");
    }
    if (await this.callConfirmation(content)) {
      this.spinner.show();
      this.preferenceService
        .activeInactiveDealer(dealerId)
        .then(async (res) => {
          if (res) {
            let successmsg = this.translate.instant("lblSuccessMessageToaster");
            this.toastr.success(successmsg);
           await this.getAllActiveDealer();
          } else {
            let warningmsg = this.translate.instant("lblWarningMessageToaster");
            this.toastr.warning(warningmsg);  
          }
          this.spinner.hide();
        },
          (err) => {
            this.spinner.hide();
          });
    }
  }
  async callConfirmation(content) {
    return this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title", centered: true })
      .result.then(
        (result) => {
          return result
        },
        (reason) => {
          return false;
        }
      );
  }
  async getAllActiveDealer() {
    this.spinner.show();
    try {
      const res = await this.preferenceService.getAllActiveDealer();
      if (res) {
        this.allDealerList.forEach(item => {
          let activeDealer = res.find(d => d.dealerId === item.dealerId);
          if (activeDealer) {
            item.isActiveDealerForPreference = activeDealer.isActive;
          }
        });
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
    }
  }
}
